/* ==========================================================
   LUXURY HEADER JS
   PART 5
   ========================================================== */

document.addEventListener('DOMContentLoaded', () => {

  /* ==========================================================
     STICKY HEADER
     ========================================================== */

  const header = document.querySelector('.luxury-header');

  if (header) {

    const handleHeaderScroll = () => {

      if (window.scrollY > 40) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }

    };

    handleHeaderScroll();

    window.addEventListener('scroll', handleHeaderScroll, {
      passive: true
    });

  }

  /* ==========================================================
     ANNOUNCEMENT SLIDER
     ========================================================== */

  const slider = document.querySelector('.luxury-announcement-slider');

  if (slider) {

    const slides = slider.querySelectorAll('.luxury-slide');
    const nextBtn = document.querySelector('.luxury-next');
    const prevBtn = document.querySelector('.luxury-prev');

    if (slides.length > 1) {

      let current = 0;
      let autoplay;

      slides.forEach((slide, index) => {

        slide.style.display =
          index === 0 ? 'block' : 'none';

      });

      const showSlide = (index) => {

        slides.forEach((slide) => {

          slide.style.display = 'none';
          slide.style.opacity = '0';

        });

        slides[index].style.display = 'block';

        requestAnimationFrame(() => {
          slides[index].style.opacity = '1';
        });

      };

      const nextSlide = () => {

        current++;

        if (current >= slides.length) {
          current = 0;
        }

        showSlide(current);

      };

      const prevSlide = () => {

        current--;

        if (current < 0) {
          current = slides.length - 1;
        }

        showSlide(current);

      };

      const startAutoplay = () => {

        autoplay = setInterval(() => {
          nextSlide();
        }, 5000);

      };

      const stopAutoplay = () => {

        clearInterval(autoplay);

      };

      nextBtn?.addEventListener('click', () => {

        stopAutoplay();
        nextSlide();
        startAutoplay();

      });

      prevBtn?.addEventListener('click', () => {

        stopAutoplay();
        prevSlide();
        startAutoplay();

      });

      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);

      startAutoplay();

    }

  }

  /* ==========================================================
     MOBILE DRAWER
     ========================================================== */

  const drawer = document.querySelector('.luxury-mobile-menu');
  const overlay = document.querySelector('.luxury-mobile-overlay');

  const openBtn =
    document.querySelector('.luxury-hamburger');

  const closeBtn =
    document.querySelector('.luxury-mobile-close');

  const openDrawer = () => {

    if (!drawer) return;

    drawer.classList.add('active');

    overlay?.classList.add('active');

    document.body.classList.add('overflow-hidden');

  };

  const closeDrawer = () => {

    drawer?.classList.remove('active');

    overlay?.classList.remove('active');

    document.body.classList.remove('overflow-hidden');

  };

  openBtn?.addEventListener('click', openDrawer);

  closeBtn?.addEventListener('click', closeDrawer);

  overlay?.addEventListener('click', closeDrawer);

  const mobileAccordions = drawer?.querySelectorAll(
  '.luxury-mobile-accordion'
);

mobileAccordions?.forEach((accordion) => {
  accordion.addEventListener('toggle', () => {
    if (!accordion.open) return;

    mobileAccordions.forEach((otherAccordion) => {
      if (otherAccordion !== accordion) {
        otherAccordion.open = false;
      }
    });
  });
});

  /* ==========================================================
     ESCAPE KEY SUPPORT
     ========================================================== */

  document.addEventListener('keydown', (event) => {

    if (event.key === 'Escape') {
      closeDrawer();
    }

  });

  /* ==========================================================
     FOCUS TRAP
     ========================================================== */

  if (drawer) {

    drawer.addEventListener('keydown', (event) => {

      if (event.key !== 'Tab') return;

      const focusable = drawer.querySelectorAll(
        'a, button, input, select, textarea'
      );

      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (
        event.shiftKey &&
        document.activeElement === first
      ) {

        event.preventDefault();
        last.focus();

      }

      if (
        !event.shiftKey &&
        document.activeElement === last
      ) {

        event.preventDefault();
        first.focus();

      }

    });

  }

  /* ==========================================================
     MEGA MENU CATEGORY SWITCHING
     ========================================================== */

  const categoryItems =
    document.querySelectorAll('.luxury-category-item');

  const panels =
    document.querySelectorAll('.luxury-submenu-panel');

  if (
    categoryItems.length &&
    panels.length
  ) {

    categoryItems.forEach((item) => {

      item.addEventListener('mouseenter', () => {

        const target =
          item.dataset.category;

        categoryItems.forEach((el) => {

          el.classList.remove('is-active');

        });

        panels.forEach((panel) => {

          panel.classList.remove('active');

        });

        item.classList.add('is-active');

        document
          .querySelector(
            `.luxury-submenu-panel[data-panel="${target}"]`
          )
          ?.classList.add('active');

      });

    });

  }

  /* ==========================================================
     TOUCH SUPPORT
     ========================================================== */

  if ('ontouchstart' in window) {

    document
      .querySelectorAll('.has-mega-menu')
      .forEach((item) => {

        const trigger =
          item.querySelector('.luxury-nav-link');

        trigger?.addEventListener('click', (event) => {

          if (
            window.innerWidth > 989 &&
            !item.classList.contains('touch-open')
          ) {

            event.preventDefault();

            document
              .querySelectorAll('.has-mega-menu')
              .forEach((el) => {

                el.classList.remove('touch-open');

              });

            item.classList.add('touch-open');

          }

        });

      });

    document.addEventListener('click', (event) => {

      if (
        !event.target.closest('.has-mega-menu')
      ) {

        document
          .querySelectorAll('.has-mega-menu')
          .forEach((el) => {

            el.classList.remove('touch-open');

          });

      }

    });

  }

  /* ==========================================================
     COLLECTION CARD REVEAL
     ========================================================== */

  const cards =
    document.querySelectorAll(
      '.luxury-collection-card'
    );

  if ('IntersectionObserver' in window) {

    const observer =
      new IntersectionObserver((entries) => {

        entries.forEach((entry) => {

          if (entry.isIntersecting) {

            entry.target.classList.add('revealed');

            observer.unobserve(entry.target);

          }

        });

      }, {
        threshold: 0.15
      });

    cards.forEach((card) => {

      observer.observe(card);

    });

  }

  /* ==========================================================
     BUTTON RIPPLE EFFECT
     ========================================================== */

  document
    .querySelectorAll(
      '.luxury-action-btn, .luxury-promo-button'
    )
    .forEach((button) => {

      button.addEventListener('click', (event) => {

        const ripple =
          document.createElement('span');

        ripple.className = 'luxury-ripple';

        const rect =
          button.getBoundingClientRect();

        ripple.style.left =
          event.clientX - rect.left + 'px';

        ripple.style.top =
          event.clientY - rect.top + 'px';

        button.appendChild(ripple);

        setTimeout(() => {
          ripple.remove();
        }, 600);

      });

    });

  /* ==========================================================
     RESIZE HANDLER
     ========================================================== */

  let resizeTimer;

  window.addEventListener('resize', () => {

    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {

      if (window.innerWidth > 989) {
        closeDrawer();
      }

    }, 200);

  });

    /* ==========================================================
     SHRINE CART DRAWER BRIDGE
     ========================================================== */

  if (!window.luxuryCartBridgeInitialized) {
    window.luxuryCartBridgeInitialized = true;

    const cartBadgeSelector =
      '.luxury-cart-count, .luxury-mobile-cart-count';

    const updateLuxuryCartBadges = (itemCount) => {
      document
        .querySelectorAll(cartBadgeSelector)
        .forEach((badge) => {
          badge.textContent = itemCount;
          badge.hidden = itemCount === 0;
          badge.setAttribute(
            'aria-label',
            `${itemCount} item${itemCount === 1 ? '' : 's'} in cart`
          );
        });
    };

    const refreshLuxuryCartCount = async () => {
      try {
        const cartUrl =
          window.Shopify?.routes?.root
            ? `${window.Shopify.routes.root}cart.js`
            : '/cart.js';

        const response = await fetch(cartUrl, {
          headers: {
            Accept: 'application/json'
          }
        });

        if (!response.ok) return;

        const cart = await response.json();

        updateLuxuryCartBadges(cart.item_count);
      } catch (error) {
        console.warn(
          'Luxury header cart count could not be refreshed.',
          error
        );
      }
    };

    const openShrineCartDrawer = (event) => {
      const cartTrigger = event.target.closest(
        '.luxury-cart-btn, .luxury-mobile-cart'
      );

      if (!cartTrigger) return;

      const cartDrawer = document.querySelector('cart-drawer');

      if (
        cartDrawer &&
        typeof cartDrawer.open === 'function'
      ) {
        event.preventDefault();

        document
          .querySelector('.luxury-mobile-menu')
          ?.classList.remove('active');

        document
          .querySelector('.luxury-mobile-overlay')
          ?.classList.remove('active');

        document.body.classList.remove('overflow-hidden');

        cartDrawer.open();
        refreshLuxuryCartCount();

        return;
      }

      const nativeCartTrigger = document.querySelector(
        '#cart-icon-bubble, [data-cart-drawer-trigger]'
      );

      if (
        nativeCartTrigger &&
        nativeCartTrigger !== cartTrigger
      ) {
        event.preventDefault();
        nativeCartTrigger.click();
        refreshLuxuryCartCount();
      }

      // If no drawer exists, the normal /cart link remains as fallback.
    };

    document.addEventListener('click', openShrineCartDrawer);

    [
      'cart:updated',
      'cart:update',
      'cart:change',
      'cart:refresh',
      'product:added'
    ].forEach((eventName) => {
      document.addEventListener(
        eventName,
        refreshLuxuryCartCount
      );
    });

    const originalFetch = window.fetch.bind(window);

    window.fetch = async (...args) => {
      const response = await originalFetch(...args);

      const request = args[0];

      const requestUrl =
        typeof request === 'string'
          ? request
          : request?.url || '';

      const isCartMutation =
        /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(
          requestUrl
        );

      if (isCartMutation && response.ok) {
        window.setTimeout(refreshLuxuryCartCount, 100);
      }

      return response;
    };

    refreshLuxuryCartCount();
  }

});

/* ==========================================================
   DESKTOP MEGA MENU HOVER
   ========================================================== */

document
  .querySelectorAll('.luxury-nav-item.has-mega-menu')
  .forEach((item) => {
    const trigger = item.querySelector('.luxury-nav-trigger');
    const menu = item.querySelector('.luxury-mega-menu');

    if (!trigger || !menu) return;

    let closeTimer;

    const openMenu = () => {
      window.clearTimeout(closeTimer);

      document
        .querySelectorAll('.luxury-nav-item.has-mega-menu')
        .forEach((otherItem) => {
          if (otherItem === item) return;

          otherItem.classList.remove('is-menu-open');

          const otherTrigger = otherItem.querySelector(
            '.luxury-nav-trigger'
          );

          const otherMenu = otherItem.querySelector(
            '.luxury-mega-menu'
          );

          otherTrigger?.setAttribute('aria-expanded', 'false');
          otherMenu?.classList.remove('mega-active');
        });

      item.classList.add('is-menu-open');
      menu.classList.add('mega-active');
      trigger.setAttribute('aria-expanded', 'true');
    };

    const closeMenu = () => {
      window.clearTimeout(closeTimer);

      closeTimer = window.setTimeout(() => {
        item.classList.remove('is-menu-open');
        menu.classList.remove('mega-active');
        trigger.setAttribute('aria-expanded', 'false');
      }, 30);
    };

    item.addEventListener('mouseenter', openMenu);
    item.addEventListener('mouseleave', closeMenu);

    menu.addEventListener('mouseenter', () => {
      window.clearTimeout(closeTimer);
    });

    menu.addEventListener('mouseleave', closeMenu);

    item.addEventListener('focusin', openMenu);

    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) {
        closeMenu();
      }
    });
  });